import React from 'react';
import { describeRange, fmtISODate, rangeIsReversed } from '../../utils/dateRange';

const bar = {
  display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
  background: 'white', border: '1px solid #e5e7eb', borderRadius: 8,
  padding: '10px 14px', marginBottom: 16,
};
const field = { display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#6b7280' };
const input = { padding: '6px 8px', borderRadius: 6, border: '1px solid #e5e7eb', fontSize: 14 };
const btn = (disabled) => ({
  padding: '6px 12px', borderRadius: 6, border: '1px solid #d1d5db', background: 'white',
  fontSize: 13, fontWeight: 600, color: '#374151',
  cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
});

/**
 * Start / End date for the whole client page. Both blank = all time.
 *
 * Controlled: the page owns the two strings. A native date input only ever
 * reports '' or a complete YYYY-MM-DD, so filtering on every change is safe --
 * there is no half-typed date to filter on, and no Apply button is needed.
 *
 * `since` is sinceLastInvoiced()'s result (or null); `sinceApplied` says
 * whether the range on screen is still exactly that one, so the label naming
 * the invoice disappears as soon as either date is hand-edited.
 */
export default function DateRangeFilter({
  startDate, endDate, onChange, since, sinceApplied, sinceDisabledReason,
}) {
  const reversed = rangeIsReversed(startDate, endDate);
  return (
    <div style={bar} role="group" aria-label="Date range">
      <label style={field}>
        Start date
        <input
          type="date" style={input} value={startDate}
          onChange={(e) => onChange(e.target.value, endDate)}
        />
      </label>
      <label style={field}>
        End date
        <input
          type="date" style={input} value={endDate}
          onChange={(e) => onChange(startDate, e.target.value)}
        />
      </label>
      <button
        type="button" style={btn(!since)} disabled={!since}
        title={since ? `From ${fmtISODate(since.startDate)}, the day after invoice #${since.invoice.number}` : sinceDisabledReason}
        onClick={() => onChange(since.startDate, since.endDate)}
      >
        Since last invoiced
      </button>
      <button
        type="button" style={btn(false)}
        onClick={() => onChange('', '')}
      >
        All time
      </button>
      <span style={{ fontSize: 13, color: '#374151' }}>
        {sinceApplied && since && (
          <strong>
            {`Since last invoice (#${since.invoice.number}, ${fmtISODate(since.invoice.date)}): `}
          </strong>
        )}
        <span>{describeRange(startDate, endDate)}</span>
      </span>
      {reversed && (
        <span role="alert" style={{ fontSize: 13, color: '#b91c1c' }}>
          Start date is after End date — nothing can match.
        </span>
      )}
    </div>
  );
}
